import type { FC, ReactNode } from 'react'
import type { GaleriaItem } from '@/types'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'
import Container from '@/components/generals/container'
import SectionHeading from '@/components/generals/section-heading'
import GalleryGrid from '@/components/gallery/gallery-grid'

interface InspirationSectionProps {
    galeria: Array<GaleriaItem>
}

const InspirationSection: FC<InspirationSectionProps> = ({ galeria }): ReactNode => {
    return (
        <section id='galeria-inspiracion' aria-labelledby='galeria-inspiracion-titulo' className='bg-black py-24 md:py-32'>
            <Container>
                <div className='mb-12 flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between'>
                    <SectionHeading
                        id='galeria-inspiracion-titulo'
                        eyebrow='Galería de inspiración'
                        title='Reconocimientos que cuentan historias.'
                        description='Ideas para premiaciones empresariales, eventos deportivos, ceremonias académicas, homenajes, aniversarios y distinciones institucionales.'
                    />

                    <Link href='/galeria' className={buttonVariants({ variant: 'outline' })}>
                        Ver galería completa
                        <ArrowRight aria-hidden='true' />
                    </Link>
                </div>

                <GalleryGrid items={galeria} limit={6} />

                <p className='mt-10 text-xs leading-relaxed text-ivory/50'>
                    Imágenes de referencia con fines demostrativos. No corresponden a trabajos reales de clientes.
                </p>
            </Container>
        </section>
    )
}

export default InspirationSection
